import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";

const EmailHeader = ({ feedbackData, topic }: any) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (topic) {
      const stateObj = {
        pageType: "mainReportPage",
        topic: topic,
      };
      navigate(`/view-tickets/${topic}`, { state: stateObj });
    } else {
      const stateObj = {
        pageType: "mainReportPage",
      };
      navigate(`/view-uncategorized-ticket`, { state: stateObj });
    }
  };
  return (
    <Grid
      container
      alignItems="center"
      gap="10px"
      sx={{
        color: "#3D4043",
        padding: "18px",
        borderBottom: "1px solid #E9E9E9",
      }}
    >
      <IconButton
        sx={{
          paddingTop: "8px",
        }}
        onClick={handleBack}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
        >
          <g opacity="0.5" clip-path="url(#clip0_1205_1601)">
            <path
              d="M15.9782 7.30663C15.9086 7.29535 15.8383 7.29014 15.7678 7.29105H3.77466L4.03617 7.16942C4.29179 7.04843 4.52434 6.88377 4.7234 6.68288L8.08659 3.3197C8.52952 2.89687 8.60395 2.21667 8.26296 1.70805C7.86609 1.16605 7.105 1.04837 6.56297 1.44524C6.51918 1.47732 6.47756 1.51229 6.43844 1.54992L0.35674 7.63163C-0.118546 8.10638 -0.118964 8.87651 0.355789 9.3518C0.356093 9.3521 0.356436 9.35244 0.35674 9.35275L6.43844 15.4345C6.91411 15.9088 7.68424 15.9077 8.15862 15.4321C8.19594 15.3946 8.2308 15.3548 8.26296 15.3128C8.60395 14.8042 8.52952 14.124 8.08659 13.7012L4.72949 10.3319C4.55103 10.1533 4.34584 10.0035 4.12132 9.88794L3.75641 9.72373H15.7009C16.3222 9.74681 16.8674 9.31276 16.9841 8.70201C17.0917 8.03891 16.6413 7.41421 15.9782 7.30663Z"
              fill="black"
            />
          </g>
          <defs>
            <clipPath id="clip0_1205_1601">
              <rect width="17" height="17" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </IconButton>
      <Box>
        <Typography
          fontSize="18px"
          fontWeight="600"
          sx={{
            color: "#3D4043",
          }}
        >
          {feedbackData?.userId}
        </Typography>
      </Box>
      {/* <Box>
        <Typography
          sx={{
            color: "#3D4043",
          }}
        >
          {feedbackData.userId}
        </Typography>
      </Box> */}
    </Grid>
  );
};
export default EmailHeader;
